module.exports = __webpack_public_path__ + "img/LocalMallOutlined.798598ad.svg";